import * as pdfjs from 'pdfjs-dist';

// Setting worker path to worker bundle.
if (import.meta.env.MODE !== 'test') {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;
}

export default pdfjs;
